import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { SignUp } from "../../Component";
import { PopupProvider } from "../../Component/Login/PopupContext";
import { useScrollToTopWithDelay } from '../../hooks';
import { 
  LanguageProvider,
  SingupPageContext,
  SingupPageContextProvider,
} from "../../store";
import styles from "./SignUpPage.module.css";

const SignUpPage = () => {
  useScrollToTopWithDelay(500);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div>
      {isLoading && (
        <div className={styles.loaderWrapper}>
          <span className={styles.loader}></span>
        </div>
      )}
      <LanguageProvider>
        <SingupPageContextProvider>
          <PopupProvider>
            <SignUp />
          </PopupProvider>
        </SingupPageContextProvider>
      </LanguageProvider>
    </div>
  );
};

export default SignUpPage;
